import React from 'react';

// Custom SVG logo for UAB MAIŠIAGALA GROUP
// Clean "M" and "G" side by side — no divider, no overlap.
// Wordmark: MAIŠIAGALA GROUP — both words in gold, single line.

export const LogoMark = ({ size = 40, color = '#D4AF37', className = '' }) => (
  <svg
    width={size}
    height={(size * 64) / 80}
    viewBox="0 0 80 64"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    aria-label="MAIŠIAGALA GROUP logo mark"
    data-testid="logo-mark"
  >
    {/* Outer architectural frame */}
    <rect
      x="1"
      y="1"
      width="78"
      height="62"
      stroke={color}
      strokeWidth="1.2"
      fill="none"
    />

    {/* M — left side */}
    <path
      d="M 8 48 L 8 16 L 20 36 L 32 16 L 32 48"
      stroke={color}
      strokeWidth="2"
      fill="none"
      strokeLinejoin="miter"
      strokeLinecap="square"
    />

    {/* G — right side */}
    <path
      d="M 72 22 C 72 18, 66 15, 60 15 C 52 15, 48 22, 48 32 C 48 42, 52 49, 60 49 C 66 49, 72 46, 72 41 L 72 32 L 62 32"
      stroke={color}
      strokeWidth="2"
      fill="none"
      strokeLinecap="square"
      strokeLinejoin="miter"
    />
  </svg>
);

export const Logo = ({ variant = 'horizontal', className = '', onClick }) => {
  if (variant === 'stacked') {
    return (
      <div
        className={`flex flex-col items-center gap-4 ${className}`}
        onClick={onClick}
        data-testid="logo-stacked"
      >
        <LogoMark size={72} />
        <div className="font-serif text-gold text-base sm:text-lg tracking-[0.32em] leading-none whitespace-nowrap">
          MAIŠIAGALA GROUP
        </div>
      </div>
    );
  }

  return (
    <div
      className={`flex items-center gap-4 ${className}`}
      onClick={onClick}
      data-testid="logo-horizontal"
    >
      <LogoMark size={44} />
      <div className="font-serif text-gold text-sm sm:text-base tracking-[0.28em] leading-none whitespace-nowrap">
        MAIŠIAGALA GROUP
      </div>
    </div>
  );
};

export default Logo;
